import "./App.css";
import Footer from "./components/footer";
import Header from "./components/header";
import View from "./components/view";
import "./utils/tradutor-i18n";

function App() {
  return (
    <>
      <Header />
      <View />
      <Footer />
    </>
  );
}

export default App;
